'use client';

import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../../lib/utils';

export function AnnouncementBannerShared({
  children,
  className,
  ...props
}: {
  children: ReactNode;
} & HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-name="announcement-banner"
      className={cn(
        'flex h-[var(--announcement-height)] w-full items-center justify-center overflow-hidden',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
